import { reduceModelHandler } from 'utils/model';
import { FETCH_SYS_INFO } from './actions';

const initialState = {};

export default function sysInfo(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case FETCH_SYS_INFO:
      return reduceModelHandler(state, action);

    default:
      return state;
  }
}
